import swal from "sweetalert";

import {
  CREATE_PATIENT_CV_FAIL,
  CREATE_PATIENT_CV_REQUEST,
  CREATE_PATIENT_CV_SUCCESS,
  CREATE_PATIENT_FAIL,
  CREATE_PATIENT_INFO_FAIL,
  CREATE_PATIENT_INFO_REQUEST,
  CREATE_PATIENT_INFO_SUCCESS,
  CREATE_PATIENT_REQUEST,
  CREATE_PATIENT_SUCCESS,
  FETCH_PATIENT_FAIL,
  FETCH_PATIENT_REPORT_FAIL,
  FETCH_PATIENT_REPORT_REQUEST,
  FETCH_PATIENT_REPORT_SUCCESS,
  FETCH_PATIENT_REQUEST,
  FETCH_PATIENT_SUCCESS,
  SHOW_PATIENT_FAIL,
  SHOW_PATIENT_REQUEST,
  SHOW_PATIENT_SUCCESS,
} from "../../ActionType/PatientType/PatientType";
import { api } from "../../Api/api";
import { getToken } from "../login";
import { createVisitAction } from "../VisitAction/VisitAction";

export const getPatientAction =
  (
    page,
    perPage,
    fullname,
    code,
    gender,
    phone,
    birthDate,
    assign,
    followUpAssign,
    reject
  ) =>
  async (dispatch) => {
    const branch_id = localStorage.getItem("branch_id");
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        page,
        perPage,
        fullname,
        code,
        gender,
        phone,
        birthDate,
        branch_id,
        assign,
        followUpAssign,
        reject,
      },
    };
    dispatch({
      type: FETCH_PATIENT_REQUEST,
      payload: [],
    });
    try {
      const response = await api.get("patient", config);
      const { status, data } = response;

      if (status == 200) {
        dispatch({
          type: FETCH_PATIENT_SUCCESS,
          payload: { data: data.patient, total: data.total },
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_PATIENT_FAIL,
        payload: [],
      });
    }
  };

export const getPatientReportAction =
  (page, perPage, fullname, code, gender, phone, birthDate, from, to, reject) =>
  async (dispatch) => {
    const branch_id = localStorage.getItem("branch_id");
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        page,
        perPage,
        fullname,
        code,
        gender,
        phone,
        birthDate,
        branch_id,
        from,
        to,
        reject,
      },
    };
    dispatch({
      type: FETCH_PATIENT_REPORT_REQUEST,
      payload: [],
    });
    // console.log(reject)
    try {
      const response = await api.get("patient/report", config);
      const { status, data } = response;

      if (status == 200) {
        dispatch({
          type: FETCH_PATIENT_REPORT_SUCCESS,
          payload: { data: data.report, total: data.total },
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_PATIENT_REPORT_FAIL,
        payload: [],
      });
    }
  };

export const showPatientAciton = (id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: SHOW_PATIENT_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get(`patient/show/${id}`, config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: SHOW_PATIENT_SUCCESS,
        payload: { data: data },
      });
    }
  } catch (error) {
    dispatch({
      type: SHOW_PATIENT_FAIL,
      payload: [],
    });
  }
};

export const updatePatientInfoAction =
  (patient_id, patientInfoId, fullname, phone, gender, birthdate) =>
  async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    try {
      const response = await api.put(
        `patient/info/update/${patientInfoId}`,
        {
          fullname,
          phone,
          gender,
          birth_date: birthdate,
        },
        config
      );
      const { status, data } = response;

      if (status == 200) {
        dispatch(showPatientAciton(patient_id));
        dispatch(showPatientAciton(patient_id));
        swal({
          title: "Good job!",
          text: "Patient was Updated Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      dispatch({
        type: SHOW_PATIENT_FAIL,
        payload: [],
      });
    }
  };

export const updateAssignPatientInfoAction =
  (id, assign) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    try {
      const response = await api.put(
        `patient/info/updateAssign/${id}`,
        {
          assign,
        },
        config
      );
      const { status, data } = response;

      // console.log(response)
    } catch (error) {
      dispatch({
        type: SHOW_PATIENT_FAIL,
        payload: [],
      });
    }
  };

export const createPatientAction =
  (fullname, gender, phone, birthDate, image) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_PATIENT_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post("patient/create", {}, config);
      const { status, data } = response;

      if (status == 201) {
        if (image.length > 0) {
          dispatch(createPatientCvAction(data.id, image));
        }

        dispatch(
          createPatientInfoAction(fullname, gender, phone, birthDate, data.id)
        );

        dispatch(createVisitAction(data.id));

        swal({
          title: "Good job!",
          text: "Patient was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch(
          getPatientAction(0, 10, "", "", "", "", "", [0, 1, 2], [0, 1], 0)
        );
        dispatch(
          getPatientAction(0, 10, "", "", "", "", "", [0, 1, 2], [0, 1], 0)
        );
        dispatch({
          type: CREATE_PATIENT_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_PATIENT_FAIL,
        payload: [],
      });
    }
  };

export const createPatientCvAction =
  (patient_id, image) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_PATIENT_CV_REQUEST,
      payload: [],
    });

    const formData = new FormData();
    formData.append("patient_id", patient_id);
    // console.log(image,"  : images : ")
    image.map((image) => {
      formData.append("cv[]", image);
    });
    try {
      const response = await api.post("patient/cv/create", formData, config);

      const { status, data } = response;
      if (status == 200) {
        dispatch({
          type: CREATE_PATIENT_CV_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: CREATE_PATIENT_CV_FAIL,
        payload: [],
      });
    }
  };

export const deletePatientCvAction = (patientCvId,patientId) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };

  try {
    const response = await api.delete(
      `patient/cv/delete/${patientCvId}`,
      config
    );
    
    const { status, data } = response;

    if (status == 200) {
      dispatch(showPatientAciton(patientId))
      dispatch(showPatientAciton(patientId))
      swal({
        icon: "success",
        timer: 1500,
        text: "Good Job",
        text: "Delete Image Successfully",
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({
      type: CREATE_PATIENT_CV_FAIL,
      payload: [],
    });
  }
};

export const createPatientInfoAction =
  (fullname, gender, phone, birthDate, patient_id) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };

    dispatch({
      type: CREATE_PATIENT_INFO_REQUEST,
      payload: [],
    });
    const branch_id = localStorage.getItem("branch_id");
    try {
      const response = await api.post(
        "patient/info/create",
        {
          fullname,
          gender,
          phone,
          birth_date: birthDate,
          branch_id,
          patient_id,
        },
        config
      );
      const { status, data } = response;
      if (status == 200) {
        dispatch({
          type: CREATE_PATIENT_INFO_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({
        type: CREATE_PATIENT_INFO_FAIL,
        payload: [],
      });
    }
  };
